export const SIDEBAR_MAX_WIDTH = 1700;
export const SIDEBAR_MIN_WIDTH = 500;
export const SIDEBAR_DEFAULT_WIDTH = 1000;
export const SIDEBAR_MOBILE_WIDTH = 768;
